import styled, { keyframes } from 'styled-components'

export const Wrapper = styled.div`
    width: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
        display: none;
    }
    & > table {
        width: auto;
        min-width: 100%;
        margin-bottom: unset;
    }
`

export const fadeInForLastRowInParentTable = keyframes`
    from {
        opacity: 0;
        top: 0;
    }

    to {
        opacity: 1;
        top:  calc(-100% - 5px);
    }
`

export const STable = styled.table`
    table-layout: fixed;

    & > tbody > tr > td {
        word-wrap: break-word;
        max-width: 320px;
    }

    & > thead > tr > th {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: var(--font-weight-bold);
    }

    tbody > tr:last-child > td > div > ul {
        top: calc(-100% - 5px);
        animation: ${fadeInForLastRowInParentTable} 0.2s ease-in-out;
    }
`

export const STableLink = styled.a`
    cursor: auto;
    -webkit-user-select: text;
    -moz-select: text;
    -ms-select: text;
    user-select: text;
    &:not(:hover) {
        color: ${({ theme }) => theme.font.darkestColor};
        text-decoration: underline;
        font-size: 14px;
    }

    &:hover {
        text-decoration: underline;
        color: ${({ theme }) => theme.font.successColor};
        cursor: pointer;
    }

    &:active {
        text-decoration: underline;
        color: ${({ theme }) => theme.font.midDarkColor};
    }
`

export const THead = styled.thead`
    position: sticky;
    top: 0;
    background-color: #ffff;
    z-index: 1;
    &::-webkit-scrollbar {
        display: none;
    }
    @media (max-width: 900px) {
        table-layout: auto;
    }
    color: ${({ theme }) => theme.font.midDarkColor};
    font-size: 13px;
`

export const SStyledRow = styled.tr`
    &.clickable {
        cursor: pointer;
        transition: background-color ${({ theme }) => theme.transition};
    }
`
